<template>
  <div class="edit-synonyms-compact form-group">
    <label class="form-label">Search Synonyms</label>
    <div class="tag-input-wrapper">
      <!-- Existing synonyms as chips -->
      <span
        v-for="(synonym, index) in synonyms"
        :key="index"
        class="tag-chip">
        {{ synonym }}
        <span class="tag-remove" @click="removeSynonym(index)">&times;</span>
      </span>

      <!-- Inline text input -->
      <input
        ref="input"
        v-model="newSynonym"
        type="text"
        class="tag-input"
        placeholder="Type and press comma to add..."
        @keyup.enter="addSynonym"
        @keyup.188="addSynonym"
        @blur="addSynonym"
      />
    </div>
    <p class="form-hint">Add alternative terms users might search for</p>
  </div>
</template>

<script>
export default {
  name: 'EditSearchSynonyms',
  props: {
    value: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      newSynonym: ''
    }
  },
  computed: {
    synonyms: {
      get() {
        return this.value || []
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    addSynonym() {
      const input = this.newSynonym.replace(/,\s*$/, '').trim()

      if (!input) return

      const newSynonyms = input
        .split(',')
        .map(s => s.trim().toLowerCase())
        .filter(s => s.length > 0)
        .filter(s => !this.synonyms.includes(s))

      if (newSynonyms.length > 0) {
        this.$emit('input', [...this.synonyms, ...newSynonyms])
      }

      this.newSynonym = ''
    },
    removeSynonym(index) {
      const updated = [...this.synonyms]
      updated.splice(index, 1)
      this.$emit('input', updated)
    }
  }
}
</script>

<style scoped>
.form-group {
  margin-bottom: 22px;
}

.form-label {
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: var(--text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 8px;
}

.tag-input-wrapper {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 10px 14px;
  border: 1px solid var(--border-light);
  border-radius: var(--radius-sm);
  background: var(--bg-secondary);
  min-height: 48px;
  align-items: center;
  cursor: text;
  transition: all 0.2s ease;
}

.tag-input-wrapper:focus-within {
  border-color: var(--feeds-green);
  box-shadow: 0 0 0 4px var(--feeds-green-light);
}

.tag-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 12px;
  background: var(--feeds-green-light);
  color: var(--feeds-green);
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
  transition: all 0.15s ease;
}

.tag-chip:hover {
  background: #d0ece9;
}

.tag-remove {
  width: 14px;
  height: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  opacity: 0.6;
  transition: opacity 0.15s;
  font-size: 14px;
  line-height: 1;
}

.tag-remove:hover {
  opacity: 1;
}

.tag-input {
  border: none;
  outline: none;
  font-size: 14px;
  font-family: inherit;
  flex: 1;
  min-width: 120px;
  background: transparent;
}

.tag-input::placeholder {
  color: var(--text-muted);
}

.form-hint {
  font-size: 12px;
  color: var(--text-muted);
  margin-top: 6px;
}
</style>
